import { render, staticRenderFns } from "./HelpDocs.vue?vue&type=template&id=65d420b0&"
import script from "./HelpDocs.vue?vue&type=script&lang=js&"
export * from "./HelpDocs.vue?vue&type=script&lang=js&"
import style0 from "./HelpDocs.vue?vue&type=style&index=0&id=65d420b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports